import React from "react";
export const replaceSelectValuesWithString = (formValues) => {
    return removeFalsyValues(Object.fromEntries(Object.entries(formValues).map(([key, value]) => {
        if (typeof value === "object") {
            return [key, value.value];
        }
        return [key, value];
    })));
};
export const removeFalsyValues = (obj) => {
    return Object.fromEntries(Object.entries(obj).filter(([, value]) => Boolean(value)));
};
export const transformDataWithConsents = (data, consents) => {
    if (!consents.length) {
        return data;
    }
    const consentPurposes = consents.map((consent) => ({
        accepted: data[consent.id] === true,
        id: consent.id,
    }));
    const result = {
        ...data,
        consent_purposes: consentPurposes,
    };
    consents.forEach((consent) => {
        delete result[consent.id];
    });
    return result;
};
export const removeWhitespacesFromPhoneNumber = (values) => Object.entries(values).reduce((acc, [key, value]) => {
    if (typeof value === "string" && /^\+?\d[\d\s]*$/.test(value)) {
        acc[key] = value.replace(/\s/g, "");
    }
    else {
        acc[key] = value;
    }
    return acc;
}, {});
export const updateCheckboxValue = (values) => Object.entries(values).reduce((acc, [key, value]) => {
    if (typeof value === "object" && Object.prototype.hasOwnProperty.call(value, "checked")) {
        acc[key] = value["checked"];
    }
    else {
        acc[key] = value;
    }
    return acc;
}, {});
export const getSuccessFields = (fields, values) => {
    const emailFieldIndexes = Object.entries(values)
        .map(([_, value], i) => (typeof value == "string" && value.includes("@") ? i : -1))
        .filter((index) => index !== -1);
    const data = Object.entries(values);
    if (emailFieldIndexes.length > 1) {
        data.splice(emailFieldIndexes[1], 1);
    }
    return fields
        ? data
            .map(([id, value]) => {
            if (!value || typeof value === "boolean")
                return;
            const option = fields?.find((option) => option.id === id);
            return (option && {
                id: option.id,
                label: option.label,
                value: typeof value === "object" ? value.label : value.toString(),
            });
        })
            .filter(Boolean)
        : [];
};
export const getConvertedChildrenDaraData = (children, preFilledFields, isPrefilledDisabled) => React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
        const options = child?.props?.block?.component?.options;
        if (Object.values(preFilledFields).includes(options?.id)) {
            options.isLocked = isPrefilledDisabled;
            options.mode = isPrefilledDisabled ? "standard" : "editable";
        }
        return child;
    }
});
//# sourceMappingURL=helpers.js.map